module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Audits px-4"
  }, [_c('v-container', [_c('div', {
    staticClass: "AuditsHeader my-3"
  }, [_c('v-row', {
    staticClass: "headerCaption",
    attrs: {
      "align-start": "",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pa-0 py-2 text-center text-md-left fill-height overflow-hidden",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('Audits.Header.audits', [_vm.demoOrgName])))])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.showAuditsMainLoading) ? _c('div', {
    staticClass: "display-1 text-center mt-5"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (_vm.isDesktopView) ? [(!_vm.hasCardsToDisplay) ? _c('v-container', {
    staticClass: "display-1 text-center grey--text",
    attrs: {
      "fluid": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Audits.noAudits')) + "\n      ")]) : _vm._l((_vm.demoDevices), function(device) {
    return _c('MainCard', {
      key: ("demo-" + (device.id)),
      attrs: {
        "id": ((device.id) + "-main-card"),
        "deviceData": device,
        "auditData": _vm.auditsData.find(function (audit) { return audit.device && audit.device.id === device.id; }),
        "flowMeasurementData": _vm.flowMeasurementsData.find(function (flowMeasurement) { return flowMeasurement.device && flowMeasurement.device.id === device.id; }),
        "pluviometricChartData": _vm.pluviometricChartsData.find(function (pluviometricChart) { return pluviometricChart.device && pluviometricChart.device.id === device.id; }),
        "uniformityData": _vm.uniformitiesData.find(function (uniformity) { return uniformity.device && uniformity.device.id === device.id; })
      }
    })
  })] : _c('v-container', {
    staticClass: "text-center mt-5 pa-5",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-icon', {
    staticClass: "mb-4",
    attrs: {
      "size": "45",
      "color": "#00202F"
    }
  }, [_vm._v("mdi-monitor")]), _vm._v(" "), _c('p', {
    staticClass: "mobile-title-text mb-2"
  }, [_vm._v("No disponible en móvil")]), _vm._v(" "), _c('p', {
    staticClass: "mobile-subtitle-text"
  }, [_vm._v("Debe acceder desde una computadora para ver este informe correctamente. La versión móvil estará disponible pronto.")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f34a63e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/AuditsDemo.vue
// module id = 1706
// module chunks = 0